import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_EXERCISE_CATEGORY } from '_api/queries';
import { ConstantsIdTitle } from '_api/types';

export const CREATE_EXERCISE_CONSTANT = 'create-exercise-constant';

export const useCreateExerciseCategoryConstant = () => {
  const queryClient = useQueryClient();
  return useApiMutation<ConstantsIdTitle, { title: string }>(
    () => '/constant/create-exercise-category',
    'post',
    {},
    {
      mutationKey: [CREATE_EXERCISE_CONSTANT],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_EXERCISE_CATEGORY] });
      },
    },
    (body) => JSON.stringify(body),
  );
};
